const names = {
  "checkout-fi": "Paytrail",
  "stripe-apple-pay": "Stripe Apple/Google Pay",
  "stripe-google-pay": "Stripe Apple/Google Pay",
};

export function getAltNames(gatewayKey) {
  return names[gatewayKey];
}
